import styled from 'styled-components';

export const Table = styled.table`
  thead {
    color: black;
    font-weight: 700;
  }
  .border {
    border: 1px solid black;
    font-weight: 500;

    + .border {
      border-left: 0px;
      border-top: 1px;
      border-right: 1px;
      border-bottom: 1px;
      border-color: black;
      border-style: solid;
    }
  }

  .pOne {
    padding: 5px 1rem;
  }

  .pTwo {
    padding: 10px;
  }

  .bold {
    font-weight: 700;
    padding: 0;
    color: black;
  }

  border-spacing: 4rem;

  tbody {
    font-size: 0.8rem;
  }
`;
